import { useEffect, useState } from 'react';
import { Box, Button, TextField, Typography, CircularProgress, Alert, Link as MuiLink } from '@mui/material';
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { clearErrors, loadUser, updatePassword } from '../../actions/userAction';
import { UPDATE_PASSWORD_RESET } from '../../constants/userConstants';
import MetaData from '../Layouts/MetaData';
import AuthLayout from './AuthLayout';

const UpdatePassword = () => {

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { error, isUpdated, loading } = useSelector((state) => state.profile);

    const [oldPassword, setOldPassword] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");

    const updatePasswordSubmitHandler = (e) => {
        e.preventDefault();

        if (newPassword.length < 8) {
            return;
        }
        if (newPassword !== confirmPassword) {
            return;
        }

        const formData = new FormData();
        formData.set("oldPassword", oldPassword);
        formData.set("newPassword", newPassword);
        formData.set("confirmPassword", confirmPassword);

        dispatch(updatePassword(formData));
    }

    useEffect(() => {
        if (error) {
            console.error(error);
            dispatch(clearErrors());
        }
        if (isUpdated) {
            dispatch(loadUser());
            navigate('/account');
            dispatch({ type: UPDATE_PASSWORD_RESET });
        }
    }, [dispatch, error, isUpdated, navigate]);

    return (
        <AuthLayout
            sidebarTitle="Update Password"
            sidebarTagline="Enter your current and new password to update"
        >
            <MetaData title="Password Update - AmritLok" />
            <Typography component="h2" variant="h5" sx={{ mb: 3, fontWeight: 600, textAlign: 'center' }}>
                Update Password
            </Typography>

            <Box component="form" onSubmit={updatePasswordSubmitHandler} sx={{ mt: 1 }}>
                {error && <Alert severity="error" sx={{ width: '100%', mb: 2 }}>{error}</Alert>}
                <TextField
                    margin="normal"
                    required
                    fullWidth
                    label="Current Password"
                    type="password"
                    name="oldPassword"
                    value={oldPassword}
                    onChange={(e) => setOldPassword(e.target.value)}
                />
                <TextField
                    margin="normal"
                    required
                    fullWidth
                    label="New Password"
                    type="password"
                    name="newPassword"
                    value={newPassword}
                    onChange={(e) => setNewPassword(e.target.value)}
                    inputProps={{ minLength: 8 }}
                    helperText={newPassword.length < 8 ? "Password must be at least 8 characters" : ""}
                    error={newPassword.length < 8}
                />
                <TextField
                    margin="normal"
                    required
                    fullWidth
                    label="Confirm New Password"
                    type="password"
                    name="confirmPassword"
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    error={confirmPassword !== newPassword}
                    helperText={confirmPassword !== newPassword ? "Passwords do not match" : ""}
                />

                <Button
                    type="submit"
                    fullWidth
                    variant="contained"
                    sx={{ mt: 3, mb: 2, py: 1.5 }}
                    disabled={loading || newPassword.length < 8 || confirmPassword !== newPassword}
                >
                    {loading ? <CircularProgress size={24} /> : 'Update'}
                </Button>

                <MuiLink
                    component={Link}
                    to="/account"
                    sx={{
                        display: 'block',
                        textAlign: 'center',
                        mt: 2,
                        textDecoration: 'none',
                        color: 'primary.main',
                    }}
                >
                    Cancel
                </MuiLink>
            </Box>
        </AuthLayout>
    );
};

export default UpdatePassword;